import { formatMessage, tryFormatMessageWithJson } from "./LanguageHelper";
import { NotificationToast } from "../../common/notification/NotificationManager";
import { ElaborationStatusItem } from "../../redux/feature/object/remote-elaborations-slice";
import {
  CAPTION_COMPONENT_MAPPING_APPLY_COMPLETED_MESSAGE,
  CAPTION_COMPONENT_MAPPING_APPLY_COMPLETED_TITLE,
  CAPTION_COMPONENT_MAPPING_APPLY_FAILED_MESSAGE,
  CAPTION_COMPONENT_MAPPING_APPLY_FAILED_TITLE,
  CAPTION_COMPONENT_MAPPING_APPLY_WARNING_TITLE,
  CAPTION_COMPONENT_MAPPING_NOT_ALL_UPDATED_MESSAGE,
} from "../../components/document/outlineCaptions";

export const APPLY_NOTIFICATION = "change-component-source-apply-notification";

export const buildComponentMappingTerminalNotification = (item: ElaborationStatusItem): NotificationToast => {
  const messages = item.messages ?? [];
  const details = messages.length > 0 ? messages : null;

  if (item.status === "REJECTED_FOR_CONCURRENCY") {
    return {
      key: APPLY_NOTIFICATION,
      title: formatMessage(CAPTION_COMPONENT_MAPPING_APPLY_FAILED_TITLE),
      message: tryFormatMessageWithJson(messages[0]?.details),
      type: "error",
      closable: true,
      removeOnClose: true,
      isTemporary: false,
    };
  }

  if (item.status !== "COMPLETED") {
    return {
      key: APPLY_NOTIFICATION,
      title: formatMessage(CAPTION_COMPONENT_MAPPING_APPLY_FAILED_TITLE),
      message: formatMessage(CAPTION_COMPONENT_MAPPING_APPLY_FAILED_MESSAGE),
      type: "error",
      closable: true,
      removeOnClose: true,
      isTemporary: false,
      details,
    };
  }

  if (messages.some((message) => message.severity === "ERROR")) {
    return {
      key: APPLY_NOTIFICATION,
      title: formatMessage(CAPTION_COMPONENT_MAPPING_APPLY_FAILED_TITLE),
      message: formatMessage(CAPTION_COMPONENT_MAPPING_NOT_ALL_UPDATED_MESSAGE),
      type: "error",
      closable: true,
      removeOnClose: true,
      isTemporary: false,
      details,
    };
  }

  if (messages.some((message) => message.severity === "WARNING")) {
    return {
      key: APPLY_NOTIFICATION,
      title: formatMessage(CAPTION_COMPONENT_MAPPING_APPLY_WARNING_TITLE),
      message: null,
      type: "warning",
      closable: true,
      removeOnClose: true,
      isTemporary: false,
      details,
    };
  }

  return {
    key: APPLY_NOTIFICATION,
    title: formatMessage(CAPTION_COMPONENT_MAPPING_APPLY_COMPLETED_TITLE),
    message: formatMessage(CAPTION_COMPONENT_MAPPING_APPLY_COMPLETED_MESSAGE),
    type: "success",
    closable: true,
    removeOnClose: true,
    isTemporary: true,
  };
};
